import React from 'react';
import { Box } from 'grommet';
import SHDImage from '@ui/Image/SHDImage';
import SHDText from '@ui/Text/SHDText';
import * as ROUTES from '@constants/routes';

interface PaywallLockDisplayProps {
  isLoggedIn: boolean;
  context: PaywallContext;
}

const PaywallLockDisplay: React.FC<PaywallLockDisplayProps> = ({
  isLoggedIn,
}) => {
  return (
    <Box align="center" pad="large" gap="medium">
      <SHDImage
        src="/paywall/paywall_lock.png"
        alt="Locked"
        width={64}
        height={64}
      />
      <Box>
        <SHDText style="subhead-bold" textAlign="center">
          This profile is private
        </SHDText>
        <SHDText style="body" textAlign="center" color="gray">
          {isLoggedIn ? (
            'You do not have access to this profile.'
          ) : (
            <SHDText style="body" textAlign="center">
              If you manage this player,{' '}
              <a
                href={`${ROUTES.SIGN_IN}?redirectUrl=${window.location.pathname.replace('/', '')})`}
                style={{
                  fontWeight: '600',
                  color: 'green',
                  textDecorationLine: 'none',
                }}
              >
                Sign in
              </a>{' '}
              to access.
            </SHDText>
          )}
        </SHDText>
      </Box>
    </Box>
  );
};

export default PaywallLockDisplay;
